/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvestigationError } from './InvestigationError';
import {
    InvestigationErrorFromJSON,
    InvestigationErrorFromJSONTyped,
    InvestigationErrorToJSON,
} from './InvestigationError';

/**
 * 
 * @export
 * @interface ManualValidationRejectionRequest
 */
export interface ManualValidationRejectionRequest {
    /**
     * 
     * @type {string}
     * @memberof ManualValidationRejectionRequest
     */
    workflowInstanceId: string;
    /**
     * 
     * @type {Array<InvestigationError>}
     * @memberof ManualValidationRejectionRequest
     */
    investigationError?: Array<InvestigationError>;
    /**
     * 
     * @type {string}
     * @memberof ManualValidationRejectionRequest
     */
    note?: string;
}

/**
 * Check if a given object implements the ManualValidationRejectionRequest interface.
 */
export function instanceOfManualValidationRejectionRequest(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    return true;
}

export function ManualValidationRejectionRequestFromJSON(json: any): ManualValidationRejectionRequest {
    return ManualValidationRejectionRequestFromJSONTyped(json, false);
}

export function ManualValidationRejectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualValidationRejectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'investigationError': json['investigationError'] == null ? undefined : ((json['investigationError'] as Array<any>).map(InvestigationErrorFromJSON)),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function ManualValidationRejectionRequestToJSON(value?: ManualValidationRejectionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'investigationError': value['investigationError'] == null ? undefined : ((value['investigationError'] as Array<any>).map(InvestigationErrorToJSON)),
        'note': value['note'],
    };
}

